import React from "react";
import Jump from "react-reveal/Jump";
import Fade from "react-reveal/Fade";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

const About = () => {
  const highlights = [
    { label: "Location", value: "Varanasi, UP, India", icon: FaMapMarkerAlt },
    { label: "Email", value: "ayushrai803@gmail.com", icon: FaEnvelope },
    { label: "Phone", value: "+91 8318542040", icon: FaPhone },
  ];

  return (
    <section
      id="about"
      className="py-20 px-4 bg-gradient-to-br from-blue-50 to-indigo-50
        dark:from-[#0a0a18] dark:to-[#0f0f1a] transition-colors duration-300"
    >
      <div className="max-w-6xl mx-auto">
        <Jump>
          <div className="text-center mb-14">
            <h2
              className="text-3xl font-extrabold uppercase tracking-widest text-gray-800 dark:text-white mb-3"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              About Me
            </h2>
            <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-[#f29f67] to-[#3b8ff3]" />
          </div>
        </Jump>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <Fade left>
            <div className="flex justify-center lg:justify-start">
              <div className="relative">
                {/* Decorative border */}
                <div className="absolute -inset-3 rounded-2xl bg-gradient-to-br from-[#f29f67] to-[#3b8ff3] opacity-20 blur-lg" />
                <div className="relative rounded-2xl p-1 bg-gradient-to-br from-[#f29f67] to-[#3b8ff3]">
                  <img
                    src="Profile-Ayush.jpeg"
                    alt="Ayush Rai"
                    className="w-72 h-80 sm:w-80 sm:h-96 object-cover rounded-xl"
                  />
                </div>
                {/* Floating badge */}
                <div className="absolute -bottom-4 -right-4 bg-gradient-to-br from-[#f29f67] to-[#f29f67]/80 
                  dark:from-[#f29f67] dark:to-[#f29f67]/90 text-white rounded-xl px-4 py-2 shadow-xl">
                  <div className="text-xs font-semibold uppercase tracking-wider">Full Stack</div>
                  <div className="text-lg font-bold" style={{ fontFamily: "'Syne', sans-serif" }}>Developer</div>
                </div>
              </div>
            </div>
          </Fade>

          {/* Content */}
          <Fade right>
            <div className="space-y-6">
              <div>
                <h3
                  className="text-2xl font-bold text-gray-800 dark:text-white mb-4"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  Passionate{" "}
                  <span className="text-[#f29f67]">Developer</span>{" "}
                  &amp; Problem Solver
                </h3>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-base">
                  I am a passionate and dedicated Full Stack Developer with hands-on experience
                  in building scalable and user-centric web applications using{" "}
                  <span className="text-[#3b8ff3] font-medium">React, Node.js, MongoDB, Next.js, FastAPI,</span> and{" "}
                  <span className="text-[#3b8ff3] font-medium">Spring Boot</span>.
                </p>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-base mt-3">
                  I love solving real-world problems with code and have built impactful projects like{" "}
                  <span className="text-[#f29f67] font-medium">JobAI</span> (an AI-powered career assistant),{" "}
                  <span className="text-[#f29f67] font-medium">ShopEasy</span> (shop and inventory management), and{" "}
                  <span className="text-[#f29f67] font-medium">Emotion Analyser</span> (real-time sentiment analysis).
                  I thrive in collaborative environments and am always eager to learn, grow, and contribute meaningfully to high-impact teams.
                </p>
              </div>

              {/* Contact Info */}
              <div className="grid grid-cols-1 gap-3">
                {highlights.map((item) => (
                  <div
                    key={item.label}
                    className="flex items-center gap-3 p-3 rounded-xl
                      bg-white/90 dark:bg-white/5 
                      border border-gray-200 dark:border-white/10
                      hover:border-[#f29f67]/40 dark:hover:border-[#f29f67]/40
                      hover:shadow-lg hover:shadow-[#f29f67]/10
                      transition-all duration-300"
                  >
                    <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#f29f67] to-[#3b8ff3]
                      flex items-center justify-center flex-shrink-0 shadow-md">
                      <item.icon className="text-white text-sm" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider">{item.label}</div>
                      <div className="text-sm font-medium text-gray-800 dark:text-gray-200">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default About;